import { Injectable } from '@angular/core';
import { SendVerificationCodeRequest } from '../models/request/send-verification-code.request';
import { SendVerificationCodeResponse } from '../models/response/send-verification-code.response';
import { AgilcredBaseService } from './agilcred-base.service';
import { Observable } from 'rxjs';
import { VerifyCodeRequest } from '../models/request/verify-code.request';
import { VerifyCodeResponse } from '../models/response/verify-code.response';

@Injectable({ providedIn: 'root' })
export class CodeVerificationService extends AgilcredBaseService {
  public sendCode(data: SendVerificationCodeRequest): Observable<SendVerificationCodeResponse> {
    return this.post('verification-code/create', data);
  }

  public verifyCode(data: VerifyCodeRequest): Observable<VerifyCodeResponse> {
    return this.post('verification-code/validate', data);
  }
}
